import Icon from '../../../components/AppIcon';


const ServicesList = ({ services }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {services?.map((service) => (
        <div
          key={service?.id}
          className="bg-card border border-border rounded-xl p-4 md:p-6 hover:shadow-warm-md transition-smooth"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <Icon name={service?.icon} size={24} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-base md:text-lg font-semibold text-foreground">
                {service?.name}
              </h4>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServicesList;